/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface DeviceState {
  width: number;
  height: number;
}

const initialState: DeviceState = {
  width: 0,
  height: 0,
};

const slice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setDeviceDimension: (state, action: PayloadAction<DeviceState>) => {
      state.width = action.payload.width;
      state.height = action.payload.height;
    },
  },
});

export const { setDeviceDimension } = slice.actions;

export default slice.reducer;
